import { Alert, Button, DatePicker, Form, Input, Select, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import dayjs from "dayjs";
import FormPage from "../common/FormPage";
import { api } from "../common/api";
import { requiredField } from "../common/common";

const targetFields = {
  VEHICLE: "vehicle",
  EQUIPMENT: "equipment",
  SETUP: "setup",
  DPI: "dpiInventoryUnit",
};

export default function NewInspection() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const type = searchParams.get("type")?.toUpperCase();
  const id = Number(searchParams.get("id"));
  const targetField = Object.hasOwn(targetFields, type) ? targetFields[type] : null;

  if (!targetField || !Number.isSafeInteger(id) || id <= 0) {
    return (
      <Alert
        type="error"
        showIcon
        title="Errore"
        description="Specificare un tipo valido (VEHICLE, EQUIPMENT, SETUP o DPI) e un ID valido nei parametri della pagina."
      />
    );
  }

  const onFinish = (data) => {
    const formData = new FormData();
    formData.append("type", type);
    formData.append(targetField, id);
    formData.append("date", data.date);
    formData.append("outcome", data.outcome);
    if (data.notes) formData.append("notes", data.notes);
    formData.append("file", data.file[0].originFileObj);
    setLoading(true);
    return api.inspection.create(formData)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };

  return (
    <FormPage title="Nuova revisione" onFinish={onFinish}>
      <Form.Item
        name="date"
        label="Data"
        rules={[requiredField]}
        getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
        normalize={(value) => value?.format("YYYY-MM-DD")}
      >
        <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item
        name="file"
        label="File"
        valuePropName="fileList"
        getValueFromEvent={(event) => event.fileList}
        rules={[{ ...requiredField, type: "array", min: 1 }]}
      >
        <Upload.Dragger accept={"application/pdf"} maxCount={1} beforeUpload={() => false}>
          <p>Trascina qui il file</p>
          <Button icon={<UploadOutlined />}>Seleziona file</Button>
        </Upload.Dragger>
      </Form.Item>
      <Form.Item name="outcome" label="Esito" rules={[requiredField]}>
        <Select
          options={[
            { label: "Positivo", value: true },
            { label: "Negativo", value: false },
          ]}
        />
      </Form.Item>
      <Form.Item name="notes" label="Note">
        <Input.TextArea rows={4} />
      </Form.Item>
      <Form.Item style={{ textAlign: "end" }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Carica
        </Button>
      </Form.Item>
    </FormPage>
  );
}
